<!-- 
程式：ODAVF109.vue
功能：2021 3月全站活動需求
作者：00812215 巫季庭
完成：2021-02-17
-->
<template>
  <div class="content_font">
    <div class="l-container">
      <div class="o-menuMask"></div>
      <div v-html="htmlContent"></div>
      <header
        class="l-header"
        style="width: 100%; position: fixed; z-index: 99; margin-top: -8px"
      >
        <div class="l-header__wrap">
          <div class="l-header__content">
            <div class="l-header__logo">
              <a href="javascript:;" id="CI_Link">
                <picture>
                  <source
                    srcset="@/assets/webpage/action1/images/logo/logo-m.svg"
                    media="(max-width: 1040px)"
                  />
                  <img
                    srcset="@/assets/webpage/action1/images/logo/logo.svg"
                    class="o-logo"
                    style="height:32px;width:auto;vertical-align:middle;"
                  />
                </picture>
              </a>
              <a
                :href="VUE_APP_LINK_WTHOME"
                target="_blank"
                title="回網路投保首頁"
                style="margin-left:32px;"
              >
                <span>網路投保</span>
              </a>
            </div>
          </div>
        </div>
      </header>
      <main class="l-main" style="margin-top: 60px">
        <!--section A-->
        <section class="l-mainKv">
          <div
            class="l-mainKv__slider slick-initialized slick-slider u-align-center"
          >
            <div class="slick-list draggable">
              <div class="o-banner f109-bg">
                <picture>
                  <source
                    srcset="@/assets/webpage/action4/images/kv-mobi.png"
                    media="(max-width: 670px)"
                  />
                  <img
                    srcset="@/assets/webpage/action4/images/kv-pc.png"
                    class="o-banner__photo f109-kv"
                    alt
                  />
                </picture>
              </div>
            </div>
          </div>
        </section>
        <!--section B-->
        <section class="l-indexAd">
          <div class="l-wrap">
            <div
              class="l-mainKv__slider slick-initialized slick-slider u-align-center"
            >
              <img
                class="title-01"
                srcset="@/assets/webpage/action4/images/title01.png"
              />
            </div>
            <div
              class="l-pageTab__content u-gutterNext--md u-align-center"
              style="margin: 0 atuo"
            >
              <p class="f109-text">
                2021/3/1～5/31凡於國泰人壽網路投保旅平險、意外傷害險、壽險任一產品，投保總件數達6,000件抽2台Gogoro
                S3、8,000件抽4台Gogoro S3、10,000件抽6台Gogoro S3！
              </p>
            </div>
            <div class="f109-total-div">
              <p class="f109-total-p">
                累積投保件數&ensp;
                <span class="f109-total" ref="totalcntstr">
                  {{ totalcntstr }}
                </span>
              </p>
            </div>
            <div class="l-pageTab__content u-gutterNext--md f109-desc">
              <label style="line-height: 2">
                補充說明：
                <br />．投保旅平險單件可獲得1次抽獎機會。
                <br />．投保意外傷害險單件可獲得5次抽獎機會。
                <br />．投保壽險單件可獲得10次抽獎機會。
              </label>
            </div>
          </div>
        </section>
        <!-- section2 -->
        <section class="l-indexAd bg-02">
          <div class="l-wrap" style="margin: 0 atuo">
            <div
              class="l-mainKv__slider slick-initialized slick-slider u-align-center"
            >
              <img
                class="title-01"
                srcset="@/assets/webpage/action4/images/title02.png"
              />
            </div>
            <div
              class="l-pageTab__content u-gutterNext--md u-align-center f109-text"
              style="margin: 0 atuo"
            >
              <p style="margin-bottom: 40px">
                2021/3/1～5/31凡於活動期間投保以下保險，即可抽取相應好禮：
              </p>
            </div>
            <div class="f109-02-divL">
              <span class="f109-h3 f109-col">［旅遊平安險］</span>
              <span class="f109-h2 f109-col">保費滿400元</span>
              <div class="div-center">
                <img
                  class="f109-reward"
                  srcset="@/assets/webpage/action4/images/reward01.png"
                />
                <div class="f109-reward-text">
                  <span class="f109-h3"
                    >全家Let's Café<br />45元任選兌換券</span
                  >
                </div>
              </div>
            </div>
            <div class="f109-02-divR">
              <span class="f109-h3 f109-col">［意外傷害險、壽險］</span>
              <span class="f109-h2 f109-col">繳費方式選擇年繳</span>
              <div class="div-center">
                <img
                  class="f109-reward"
                  srcset="@/assets/webpage/action4/images/reward02.png"
                />
                <div class="f109-reward-text-2">
                  <span class="f109-h3"
                    >Dyson 吹風機／<br />Dyson Pure Hot Cool</span
                  >
                  <br />
                  <span class="f109-h4"> HP00 三合一 涼暖空氣清淨機</span>
                </div>
              </div>
              <span class="f109-h2-2 f109-col"
                >&ensp;7-11購物金100元（免抽獎即享禮）</span
              >
            </div>
            <!-- 四種險別 -->
            <div class="l-mainProduct__container">
              <div class="l-cols__3 l-cols__6@m">
                <div class="c-productCard__main">
                  <div class="c-productCard__imgContainer">
                    <a
                      :href="VUE_APP_LINK_INSURED1"
                      target="_blank"
                      id="insurance01PIC"
                    >
                      <img
                        srcset="@/assets/webpage/action4/images/insurance01.png"
                        class="f109-img"
                      />
                    </a>
                  </div>
                  <div class="f109-insurance">
                    <a
                      :href="VUE_APP_LINK_INSURED1"
                      target="_blank"
                      style="color: #068490"
                    >
                      <span class="f109-ins-t">e悠遊</span>
                      <span class="f109-ins-b">旅行平安險&ensp;▶</span>
                    </a>
                  </div>
                </div>
              </div>
              <div class="l-cols__3 l-cols__6@m">
                <div class="c-productCard__main">
                  <div class="c-productCard__imgContainer">
                    <a
                      :href="VUE_APP_LINK_INSURED2"
                      target="_blank"
                      id="insurance02PIC"
                    >
                      <img
                        srcset="@/assets/webpage/action4/images/insurance02.png"
                        class="f109-img"
                      />
                    </a>
                  </div>
                  <div class="f109-insurance">
                    <a
                      :href="VUE_APP_LINK_INSURED2"
                      target="_blank"
                      style="color: #5b7b94"
                    >
                      <span class="f109-ins-t">iCarry</span>
                      <span class="f109-ins-b">意外傷害險&ensp;▶</span>
                    </a>
                  </div>
                </div>
              </div>
              <div class="l-cols__3 l-cols__6@m">
                <div class="c-productCard__main">
                  <div class="c-productCard__imgContainer">
                    <a
                      :href="VUE_APP_LINK_INSURED3"
                      target="_blank"
                      id="insurance03PIC"
                    >
                      <img
                        srcset="@/assets/webpage/action4/images/insurance03.png"
                        class="f109-img"
                      />
                    </a>
                  </div>
                  <div class="f109-insurance">
                    <a
                      :href="VUE_APP_LINK_INSURED3"
                      target="_blank"
                      style="color: #aa8a55"
                    >
                      <span class="f109-ins-t">iLife</span>
                      <span class="f109-ins-b">一年期定期壽險&ensp;▶</span>
                    </a>
                  </div>
                </div>
              </div>
              <div class="l-cols__3 l-cols__6@m">
                <div class="c-productCard__main">
                  <div class="c-productCard__imgContainer">
                    <a
                      :href="VUE_APP_LINK_INSURED4"
                      target="_blank"
                      id="insurance04PIC"
                    >
                      <img
                        srcset="@/assets/webpage/action4/images/insurance04.png"
                        class="f109-img"
                      />
                    </a>
                  </div>
                  <div class="f109-insurance">
                    <a
                      :href="VUE_APP_LINK_INSURED4"
                      target="_blank"
                      style="color: #8cc039"
                    >
                      <span class="f109-ins-t">iLove</span>
                      <span class="f109-ins-b">小額終身壽險&ensp;▶</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="l-indexAd">
          <div class="l-wrap">
            <p class="f109-h2-b">［領獎說明］</p>
            <div class="l-pageTab__content u-gutterNext--md f109-desc">
              <p>
                本公司將於活動期間屆滿後一個月內，以電腦隨機抽獎。再於抽獎日後一個月內，於國泰人壽官網最新消息公告得獎名單，再以網路投保之註冊Email各別通知得獎者。得獎者須於抽獎日後14日內寄回領獎確認函，逾期未領獎者，視為放棄得獎資格。
                <br />
                ※同獎項限一保戶獲得。
                <br />
                ※投保旅行平安險、保障型保險需完成繳費且無撤銷或解約之情事，方具抽獎資格。
              </p>
            </div>
            <br />
            <hr class="f109_hr" />
          </div>
        </section>

        <section>
          <div class="l-wrap">
            <p class="f109-h2-b">［注意事項］</p>
            <div class="l-pageTab__content u-gutterNext--md f109-desc">
              <ul class="o-list o-list--decimal">
                <li>本活動限自然人參加。</li>
                <li>
                  參加者於參加本活動時，即表示同意本活動辦法，並充分知悉與同意以下事項：
                  <p class="f109-desc-p">
                    &bull;&ensp;本公司得因本活動之需要，依個人資料保護相關規定，於參加者同意之期間內，以電子檔或紙本形式於我國境內蒐集、處理、利用其個人資料。但本公司於未經參加者之同意下，不得利用參加者之個人資料進行商業行銷行為。參加者可自由選擇是否提供完整個人資訊，惟若資訊不完整者，將無法參加本活動。
                  </p>
                  <p class="f109-desc-p">
                    &bull;&ensp;參加者可電洽本公司客服專線，市話請撥打免費專線：0800-036-599，手機請改撥電話：(02)
                    2162-6201或網路電話（路徑：國泰人壽官網首頁>聯絡我們>專線服務>客服專線>網路電話），針對其個人資料行使請求答覆查詢、提供閱覽、製給複製本、更正、補充、停止蒐集、處理、利用或刪除之權利，亦可至本公司官方網站法令公告之
                    「資安與個資保護聲明」 進一步了解詳細資訊。
                  </p>
                </li>
                <li>
                  本活動如有任何因電腦、網路、電話、技術或其他不可歸責於本公司之事由，致參加者所寄出、填寫或登錄之資料有遺失、錯誤、無法辨識或毀損等情形，本公司不負任何法律責任。
                </li>
                <li>
                  本公司有權檢視得獎情況是否有人為操作之行為，對於以偽造、詐欺或其他不正當之方式意圖兌領之參加者，本公司有權撤銷其得獎資格或拒絕其參與本活動。
                </li>
                <li>
                  得獎者身分之認定係依本公司資料庫電子郵件所對應（或參加者所填寫、登錄）之身分證字號為主，得獎者須提供正確之身分證影本，並經本公司確認無誤後始得領獎。
                </li>
                <li>
                  本活動獎品寄送地址僅限中華民國境內，如得獎者未能於領獎期限前回覆有效國內寄送地址，本公司得取消其得獎資格。
                </li>
                <li>
                  得獎者逾期未領獎或因留存資料不完整或錯誤致無法通知得獎者，視同放棄得獎資格，不接受開立扣繳憑單者，亦同。
                </li>
                <li>本活動獎品不得要求轉換、轉讓或折換現金。</li>
                <li>
                  本活動獎品悉以實物為準，網頁上照片、圖案等僅供參考，恕不挑色；如遇缺貨或不可抗力之因素無法提供時，本公司有權以其他等值商品替代。
                </li>
                <li>
                  依稅法規定，得獎者若為中華民國境內居住之個人，且年度所得獎項價值累積超過1,000元時，本公司將於翌年開立所得稅扣繳憑單予得獎者，如所得獎項價值達20,010元(含)時，得獎者須先繳交10%機會中獎稅金，始可領獎。得獎者若為非中華民國境內居住之個人(即在中華民國境內居住未達183天之本國人及外國人)，不論得獎獎項價值，均須先就得獎所得扣繳20%機會中獎稅金，始可領獎，本公司並將依法開立所得稅扣繳憑單。若未能依法繳納應繳稅額，即視為喪失得獎資格。參加者因參加本活動而須支付之任何稅捐皆為參加者之義務，概與本公司無關。前述稅捐法規如有更新或變動者，依修正後之規定辦理。
                </li>
                <li>
                  本公司非獎品製造者或提供者，與各項獎品或服務之製造或提供廠商無任何代理或合夥關係，且本活動獎品之保固期限均依廠商出廠時實際提供者為準。得獎者如因本活動各項獎品、服務或保固發生任何爭議，概與本公司無關。
                </li>
                <li>
                  本公司保有取消、終止、修改或暫停本活動相關內容之權利，並得以公告方式通知參加者。如有未盡事宜，悉依本公司相關規定或解釋辦理。
                </li>
              </ul>
            </div>
          </div>
        </section>
      </main>
      <footer class="l-footer">
        <div class="l-footer__contactUs">
          <div class="l-footer__wrap">
            <ul class="c-footLinks">
              <li>
                <a
                  :href="VUE_APP_LINK_MEMBER"
                  target="_blank"
                  class="c-footLinks__link"
                >
                  會員專區
                </a>
              </li>
              <li>
                <a
                  :href="VUE_APP_LINK_CONNECTION"
                  target="_blank"
                  class="c-footLinks__link"
                >
                  聯絡我們
                </a>
              </li>
              <li>
                <a
                  :href="VUE_APP_LINK_SECRET"
                  target="_blank"
                  class="c-footLinks__link"
                >
                  顧客資料保密措施
                </a>
              </li>
              <li></li>
            </ul>
          </div>
        </div>
        <div class="l-footer__copyright">
          <div class="l-footer__wrap">© 國泰人壽保險股份有限公司</div>
        </div>
      </footer>
      <a href="javascript:;" class="o-gotoTop" data-id="gotop"></a>
    </div>
    <div id="CI_LINK_MSG" class="mfp-hide" style="width: 30%; margin: 0 auto">
      <div class="c-popup__head" data-alert="title">提醒您</div>
      <div class="c-popup__content u-align-center">
        <div data-alert="content">您將離開本頁面，並前往國泰人壽官網首頁。</div>
        <div class="c-popup__actions">
          <a
            href="javascript:;"
            class="o-btn o-btn--normal"
            style="margin-right: 5px"
            data-mfp-close
          >
            取消
          </a>
          <a
            @click="gotoCathayLife"
            class="o-btn o-btn--normal o-btn--primary"
            style="margin-left: 5px"
          >
            立即前往
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DTODAV03 from "@/service/DTODAV03.js";
import DTODAV01 from "@/service/DTODAV01.js";
import $ from "jquery";
import "magnific-popup/dist/magnific-popup.css";
import "magnific-popup";

export default {
  name: "ODAVF109",
  data() {
    return {
      htmlContent: "",
      totalcntstr: "000,000",
      promptNum: 0,
      reqMap: {}, //params資料遺失時使用容器
      actId: this.$route.query.id,
      paramsData: this.$route.params.data,
      time: null,
      //國泰人壽首頁
      VUE_APP_LINK_CATHAYLIFE: process.env.VUE_APP_LINK_CATHAYLIFE,
      //網路投保首頁
      VUE_APP_LINK_WTHOME: process.env.VUE_APP_LINK_WTHOME,
      //會員專區
      VUE_APP_LINK_MEMBER: process.env.VUE_APP_LINK_MEMBER,
      //聯絡我們
      VUE_APP_LINK_CONNECTION: process.env.VUE_APP_LINK_CONNECTION,
      //顧客資料保密措施
      VUE_APP_LINK_SECRET: process.env.VUE_APP_LINK_SECRET,
      //(e悠遊旅行平安險)
      VUE_APP_LINK_INSURED1: process.env.VUE_APP_LINK_LYUPING,
      //(iCarry意外傷害險)
      VUE_APP_LINK_INSURED2: process.env.VUE_APP_LINK_YIWAI,
      //(iLife一年期定期壽險)
      VUE_APP_LINK_INSURED3: process.env.VUE_APP_LINK_ONEYEAR,
      //(iLove小額終身壽險)
      VUE_APP_LINK_INSURED4: process.env.VUE_APP_LINK_SIAOE,
    };
  },
  metaInfo() {
    let metaData = this.paramsData || this.reqMap;
    let imgUrl = metaData.img_src
      ? window.location.protocol +
        "//" +
        window.location.host +
        "/ODAV/Path/" +
        metaData.img_src
      : "";
    return {
      title: metaData.act_nm || "國泰人壽",
      meta: [
        {
          name: "keyWords",
          content: metaData.act_kws || "",
        },
        {
          name: "description",
          content: metaData.act_des || "",
        },
        {
          name: "image",
          content: imgUrl,
        },
        {
          property: "og:title",
          content: metaData.act_nm || "",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:description",
          content: metaData.act_des || "",
        },
        {
          property: "og:url",
          content: metaData.act_id
            ? window.location.protocol +
              "//" +
              window.location.host +
              "/ODAV/action/" +
              metaData.act_id
            : "",
        },
        {
          property: "og:image",
          content: imgUrl,
        },
        {
          property: "og:image:width",
          content: "1200",
        },
        {
          property: "og:image:height",
          content: "630",
        },
      ],
    };
  },
  methods: {
    // 前往國泰人壽
    gotoCathayLife() {
      window.location.href = this.VUE_APP_LINK_CATHAYLIFE;
    },
    scrollAnchor(id) {
      let animationTime = {
        type: Number,
        default: 300,
      };
      let move = $("#" + id).offset().top - 65;
      $("html").animate({ scrollTop: move }, animationTime);
    },
    getTotalCnt() {
      var num = 0;
      let cthis = this;

      this.$cathayAxios
        .post(DTODAV03.getTotalCnt, { act_id: this.actId })
        .then((resp) => {
          if (resp.returnCode === 0) {
            num = resp.data;
            $({ Counter: 0 }).animate(
              { Counter: num },
              {
                duration: 400,
                easing: "swing",
                step: function (now) {
                  const finNum = Math.ceil(now).toString().padStart(6, "0");
                  cthis.totalcntstr =
                    finNum.substr(0, 3) + "," + finNum.substr(3, 3);
                },
              }
            );
          }
        });
    },
    initFun() {
      $("#CI_Link").on("click", function (e) {
        e.preventDefault();
        $.magnificPopup.open({
          items: {
            src: "#CI_LINK_MSG",
            type: "inline",
          },
          callbacks: {
            open: function () {
              $("#CI_LINK_MSG_Link1").on("click", function (e) {
                e.preventDefault();
                window.location = VUE_APP_LINK_CATHAYLIFE;
              });

              $("#CI_LINK_MSG .o-btn--normal[data-mfp-close]").on(
                "click",
                function (e) {
                  e.preventDefault();
                  $.magnificPopup.close();
                }
              );
            },
          },
        });
      });
    },
    //畫面於指定區塊時，才開始執行支援人數計算&轉動
    getScrollNum() {
      let cthis = this;
      let distanceOfTop = $(window).scrollTop(); //畫面當前與最上方的高度
      let bannerHeight = $(".l-mainKv").height(); //banner區塊高度

      //若為初始進入(promptNum=0) 且 畫面當前高度>banner三分之二高度 且 畫面當前高度<(banner區塊高度+支持醫務區塊高度)
      if (
        this.promptNum == 0 &&
        distanceOfTop > (bannerHeight / 3) * 2 &&
        distanceOfTop < bannerHeight + $(".l-indexAd").height()
      ) {
        cthis.getTotalCnt();
        this.promptNum++;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initFun();
    });
    window.addEventListener("scroll", this.getScrollNum);
  },
  created() {
    import("@/assets/webpage/js/vendor/modernizr-3_5_0-min.js").then((m) => {});

    import("@/assets/webpage/js/vendor/picturefill/picturefill-min.js").then(
      (m) => {}
    );
    import("@/assets/webpage/js/vendor/picturefill/pf-mutation-min.js").then(
      (m) => {}
    );
    import("@/assets/webpage/js/vendor/matchMedia/matchMedia-min.js").then(
      (m) => {}
    );
    //判斷是否有paramsData，無到DB抓資料
    if (!this.paramsData) {
      this.$cathayAxios
        .post(DTODAV01.doQueryAction, { act_id: this.actId })
        .then((resp) => {
          if (resp.returnCode === 0) {
            this.reqMap = resp.data || {};
          }
        });
    }
  },
};
</script>
<style
  src="@/assets/webpage/css/jquery_fancyform/jquery_fancyform_min.css"
></style>
<style scoped src="@/assets/webpage/js/vendor/slick/slick-min.css"></style>
<style
  scoped
  src="@/assets/webpage/js/vendor/slick/slick-theme-min.css"
></style>
<style
  scoped
  src="@/assets/webpage/js/vendor/bootstrap-datepicker/bootstrap-datepicker.standalone.min.css"
></style>
<style scoped src="@/assets/webpage/css/common/normalize-min.css"></style>
<style scoped src="@/assets/webpage/css/common/animate-min.css"></style>
<style scoped src="@/assets/webpage/css/common/layout-min.css"></style>
<style scoped src="@/assets/webpage/css/form-min.css"></style>
<style scoped src="@/assets/webpage/css/product-min.css"></style>
<style scoped src="@/assets/webpage/css/index.css"></style>
<style scoped src="@/assets/webpage/css/common/main.css"></style>
<style scoped src="@/assets/third-party/css/font-awesome.min.css"></style>
<style scoped>
.c-popup__content {
  background-color: white;
}
.content_font {
  font-size: 16px;
  line-height: 1.5;
  color: #000;
  letter-spacing: 2px;
  font-family: Arial, "Microsoft JhengHei", Helvetica, sans-serif;
}
.f109-total-div {
  background-color: #ffecc1;
  border-radius: 50px;
  font-size: 24px;
  text-align: center;
  transition: all 0.3s;
}
.f109-total-p {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  transition: all 0.3s;
}
.f109-total {
  color: #b82718;
  font-size: 54px;
  font-weight: 500;
  text-align: center;
  transition: all 0.3s;
}
.f109-h2 {
  color: #b82718;
  font-size: 32px;
  font-weight: 600;
  transition: all 0.3s;
}
.f109-h2-2 {
  color: #b82718;
  margin-top: 20px;
  font-size: 24px;
  font-weight: 600;
  transition: all 0.3s;
}
.f109-h2-b {
  color: #000;
  font-size: 30px;
  font-weight: 600;
  letter-spacing: 3px;
  text-align: center;
}
.f109-h3 {
  color: #000;
  font-size: 24px;
  letter-spacing: 1px;
  white-space: pre-wrap;
}
.f109-h4 {
  color: #000;
  letter-spacing: 1px;
}
.f109-reward {
  float: left;
  margin-left: 50px;
  margin-right: 10px;
}
.f109-reward-text {
  padding-top: 20px;
  text-align: left;
}
.f109-reward-text-2 {
  padding-top: 10px;
  text-align: left;
  padding-left: 10px;
  margin-left: 20px;
}
.f109-bg {
  width: 100%;
  display: inline-block;
  margin-top: 5px;
  margin-bottom: -55px;
  background-image: url("../../../assets/webpage/action4/images/kv-pc-bg.jpg");
  background-repeat: no-repeat;
  background-size: 100%;
  transition: all 0.3s;
}
.f109-kv {
  z-index: 1;
  width: 59%;
  transition: all 0.3s;
}
.f109-text {
  font-weight: 500;
  font-size: 22px;
  line-height: 1.5;
  color: #000;
  letter-spacing: 2px;
}
.title-01 {
  margin-bottom: 2em;
  transition: all 0.3s;
}
.bg-02 {
  background-color: #ffecc1;
}
.f109-02-divL {
  width: 49%;
  float: left;
  transition: all 0.3s;
  text-align: center;
}
.f109-02-divR {
  border-left: 1px solid #000;
  display: table;
  width: 50%;
  transition: all 0.3s;
  text-align: center;
}
.f109-insurance {
  text-align: center;
  cursor: pointer;
  font-size: 22px;
  font-weight: 600;
  margin: 20px 0;
}
.f109-ins-t,
.f109-ins-b {
  display: block;
}
.div-center {
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s;
}
.c-productCard__main {
  cursor: pointer;
}
.c-productCard__main:hover .f109-img {
  -webkit-transform: scale(0.95);
  -ms-transform: scale(0.95);
  transform: scale(0.95);
  transition: all 0.3s;
}
.c-productCard__main:hover .f109-insurance {
  -webkit-transform: scale(1.05);
  -ms-transform: scale(1.05);
  transform: scale(1.05);
  transition: all 0.3s;
}
.f109_hr {
  margin-top: 10px;
  height: 36px;
  border-top: unset;
  background-color: transparent !important;
  background-image: url("../../../assets/webpage/action4/images/divide.png");
  background-repeat: repeat-x;
}
.f109-img {
  width: 100%;
  transition: all 0.3s;
}
.f109-col {
  text-align: center;
  width: 100%;
  display: table;
  transition: all 0.3s;
}
.f109-desc {
  margin: 0 atuo;
  font-size: 20px;
  padding: 0 1em;
}
.f109-desc-p {
  text-indent: -1em;
  margin-left: 1em;
}
@media (min-width: 1575px) {
  .l-mainProduct__container {
    max-height: 1200px;
    padding: 40px 10px 10px;
  }
  .prodCard {
    height: 300px;
  }
  .labelimg {
    position: absolute;
    z-index: 2;
    width: 40%;
    left: 0px;
  }
  .CTAimg {
    position: absolute;
    z-index: 2;
    top: 30%;
    left: 70%;
    width: 244px;
    cursor: pointer;
    display: block;
  }
  .CTAimg_m {
    display: none;
  }
  .ipDiv {
    left: 71%;
    display: block;
  }
  .ipDiv_m {
    display: none;
  }
  .CTA_div {
    margin: -2px 0px 0px 7%;
  }
  .totalcount {
    position: absolute;
    left: 51%;
    top: 67%;
    z-index: 2;
    font-size: 53px;
  }
  .plurkshare {
    position: absolute;
    left: 52%;
    top: 83%;
    z-index: 2;
    width: 38px;
    cursor: pointer;
  }
  .lineshare {
    position: absolute;
    left: 55%;
    top: 83%;
    z-index: 2;
    width: 38px;
    cursor: pointer;
  }
  .fbshare {
    position: absolute;
    left: 58%;
    top: 83%;
    z-index: 2;
    width: 38px;
    cursor: pointer;
  }
}
@media (max-width: 1574px) and (min-width: 1201px) {
  .l-mainProduct__container {
    max-height: 1200px;
  }
  .prodCard {
    height: 300px;
  }
  .labelimg {
    position: absolute;
    z-index: 2;
    width: 40%;
    left: 0px;
  }
  .CTAimg {
    position: absolute;
    z-index: 2;
    top: 30%;
    left: 72%;
    width: 244px;
    cursor: pointer;
    display: block;
  }
  .CTAimg_m {
    display: none;
  }
  .ipDiv {
    left: 73%;
    display: block;
  }
  .ipDiv_m {
    display: none;
  }
  .CTA_div {
    margin: -2px 0px 0px 7%;
  }
  .totalcount {
    position: absolute;
    left: 51%;
    top: 68%;
    z-index: 2;
    font-size: 46px;
  }
  .plurkshare {
    position: absolute;
    left: 52%;
    top: 83%;
    z-index: 2;
    width: 38px;
    cursor: pointer;
  }
  .lineshare {
    position: absolute;
    left: 56%;
    top: 83%;
    z-index: 2;
    width: 38px;
    cursor: pointer;
  }
  .fbshare {
    position: absolute;
    left: 60%;
    top: 83%;
    z-index: 2;
    width: 38px;
    cursor: pointer;
  }
}
@media (max-width: 1200px) and (min-width: 1024px) {
  .l-mainProduct__container {
    max-height: 1200px;
  }
  .prodCard {
    height: 300px;
  }
  .labelimg {
    position: absolute;
    z-index: 2;
    width: 40%;
    left: 0px;
  }
  .CTAimg {
    position: absolute;
    z-index: 2;
    top: 30%;
    left: 74%;
    width: 222px;
    cursor: pointer;
    display: block;
  }
  .CTAimg_m {
    display: none;
  }
  .ipDiv {
    left: 74%;
    display: block;
  }
  .ipDiv_m {
    display: none;
  }
  .CTA_div {
    margin: -2px 0px 0px 7%;
  }
  .totalcount {
    position: absolute;
    left: 51%;
    top: 69%;
    z-index: 2;
    font-size: 38px;
  }
  .plurkshare {
    position: absolute;
    left: 53%;
    top: 83%;
    z-index: 2;
    width: 3%;
    cursor: pointer;
  }
  .lineshare {
    position: absolute;
    left: 57%;
    top: 83%;
    z-index: 2;
    width: 3%;
    cursor: pointer;
  }
  .fbshare {
    position: absolute;
    left: 61%;
    top: 83%;
    z-index: 2;
    width: 3%;
    cursor: pointer;
  }
}
@media (max-width: 1023px) {
  .l-mainProduct__container {
    max-height: 1200px;
  }
  .f109-bg {
    margin-bottom: -30px;
  }
  .prodCard {
    height: 300px;
  }
  .labelimg {
    position: absolute;
    z-index: 2;
    width: 40%;
    left: 0px;
  }
  .CTAimg {
    position: absolute;
    z-index: 2;
    top: 29%;
    left: 75%;
    width: 175px;
    cursor: pointer;
    display: block;
  }
  .CTAimg_m {
    display: none;
  }
  .ipDiv {
    left: 72%;
    display: block;
  }
  .ipDiv_m {
    display: none;
  }
  .CTA_div {
    margin: -2px 0px 0px 7%;
  }
  .totalcount {
    position: absolute;
    left: 51%;
    top: 69%;
    z-index: 2;
    font-size: 30px;
  }
  .plurkshare {
    position: absolute;
    left: 53%;
    top: 83%;
    z-index: 2;
    width: 3%;
    cursor: pointer;
  }
  .lineshare {
    position: absolute;
    left: 57%;
    top: 83%;
    z-index: 2;
    width: 3%;
    cursor: pointer;
  }
  .fbshare {
    position: absolute;
    left: 61%;
    top: 83%;
    z-index: 2;
    width: 3%;
    cursor: pointer;
  }
  .f109-02-divL,
  .f109-02-divR {
    border-left: unset;
    width: 100%;
    float: unset;
    padding: 10px 0;
  }
  .f109-reward {
    float: unset;
    padding-top: 10px;
    margin-left: unset;
  }
  .f109-reward-text,
  .f109-reward-text-2 {
    display: inline-table;
  }
  .f109-h2 {
    font-size: 24px;
    letter-spacing: 1px;
  }
  .f109-h3,
  .f109-h2-2 {
    font-size: 22px;
    letter-spacing: 1px;
  }
  .f109-text {
    margin: 0 0.25em;
  }
}
@media (max-width: 767px) {
  .f109-bg {
    margin-bottom: unset;
    background-image: url("../../../assets/webpage/action4/images/kv-mobi-bg.jpg");
  }
  .f109-text {
    margin: 0 1em;
    font-size: 20px;
    letter-spacing: 1px;
  }

  .f109-kv {
    width: 100%;
  }
  .f109-total {
    font-size: 40px;
  }
  .f109-total-div {
    margin: 1em;
  }
  .f109-insurance .f109-ins-t {
    letter-spacing: 2px;
  }
  .f109-insurance .f109-ins-b {
    letter-spacing: -1px;
  }
  .f109_hr {
    height: 24px;
    background-size: contain;
  }
  .f109-desc {
    margin: 0 1em;
  }
  .title-01 {
    width: 90%;
    margin-bottom: 1em;
  }
  .l-mainProduct__container {
    max-height: 1800px;
  }
  .labelimg {
    position: absolute;
    z-index: 2;
    width: 96px;
    height: 96px;
    left: 15px;
  }
  .CTAimg {
    position: absolute;
    z-index: 2;
    top: 66%;
    left: 24%;
    width: 56%;
    cursor: pointer;
    display: none;
  }
  .CTAimg_m {
    display: block;
    top: 68%;
  }
  .ipDiv {
    display: none;
  }
  .ipDiv_m {
    display: block;
  }
  .CTA_div {
    margin: -2px 0px 0px 7%;
  }
  .totalcount {
    position: absolute;
    left: 52%;
    top: 58%;
    z-index: 2;
    font-size: 30px;
  }
  .plurkshare {
    position: absolute;
    left: 52%;
    top: 91%;
    z-index: 3;
    width: 40px;
    cursor: pointer;
  }
  .lineshare {
    position: absolute;
    left: 66%;
    top: 91%;
    z-index: 3;
    width: 40px;
    cursor: pointer;
  }
  .fbshare {
    position: absolute;
    left: 80%;
    top: 91%;
    z-index: 3;
    width: 40px;
    cursor: pointer;
  }
}
@media (max-width: 415px) {
  .totalcount {
    position: absolute;
    left: 52%;
    top: 57%;
    z-index: 2;
    font-size: 30px;
  }
  .f109-total-div {
    font-size: 20px;
    margin: 0.5em;
  }
  .f109-total {
    font-size: 32px;
    font-weight: 600;
  }
  .f109-insurance {
    font-size: 18px;
  }
  .f109-desc {
    font-size: 16px;
  }
  .f109-02-divR .f109-reward {
    margin: 0;
  }
  .f109-reward-text-2 .f109-h3 {
    font-size: 18px;
  }
  .f109-h2-2 {
    font-size: 20px;
    letter-spacing: 0;
  }
}
@media (max-width: 361px) {
  .CTA_div {
    margin: -2px 0px 0px 7%;
  }
  .totalcount {
    position: absolute;
    left: 52%;
    top: 56%;
    z-index: 2;
    font-size: 30px;
  }
  .plurkshare {
    position: absolute;
    left: 56%;
    top: 90%;
    z-index: 3;
    width: 36px;
    cursor: pointer;
  }
  .lineshare {
    position: absolute;
    left: 69%;
    top: 90%;
    z-index: 3;
    width: 36px;
    cursor: pointer;
  }
  .fbshare {
    position: absolute;
    left: 82%;
    top: 90%;
    z-index: 3;
    width: 36px;
    cursor: pointer;
  }
}
@media (max-width: 320px) {
  .CTA_div {
    margin: -2px 0px 0px 5%;
  }
  .CTAimg_m {
    display: block;
    top: 64%;
  }
  .ipDiv {
    display: none;
  }
  .ipDiv_m {
    display: block;
  }
  .totalcount {
    position: absolute;
    left: 52%;
    top: 53%;
    z-index: 2;
    font-size: 30px;
  }
  .plurkshare {
    position: absolute;
    left: 58%;
    top: 90%;
    z-index: 3;
    width: 33px;
    cursor: pointer;
  }
  .lineshare {
    position: absolute;
    left: 71%;
    top: 90%;
    z-index: 3;
    width: 33px;
    cursor: pointer;
  }
  .fbshare {
    position: absolute;
    left: 84%;
    top: 90%;
    z-index: 3;
    width: 33px;
    cursor: pointer;
  }
}
</style>
